const { routes }: any = window

export class CartAPI {
  change(config): Promise<string> {
    return fetch(routes.cart_change_url, config).then(response =>
      response.text(),
    )
  }

  add(config): Promise<string> {
    return fetch(routes.cart_add_url, config).then(response => response.text())
  }

  update(config): Promise<Response> {
    return fetch(routes.cart_update_url, config)
  }

  get(): Promise<string> {
    return fetch(routes.cart_url).then(response => response.text())
  }

  getDrawer(): Promise<string> {
    return fetch(routes.root_url).then(response => response.text())
  }
}
